import {
  ACCOUNT_DETAIL_REQUEST,
  ACCOUNT_DETAIL_SUCCESS,
  UPDATE_ACCOUNT_SUCCESS,
  REQUEST_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  SET_LOCALE_REQUEST,
  RESEND_CONFIRMATION_EMAIL_REQUEST,
  RESEND_CONFIRMATION_EMAIL_SUCCESS,
  CANCEL_EMAIL_CHANGE_REQUEST,
  CANCEL_EMAIL_CHANGE_SUCCESS,
  SET_TRAINING_DASHBOARD_TOKEN,
  GENERATE_API_KEY_REQUEST,
  GENERATE_API_KEY_SUCCESS,
  GENERATE_API_KEY_FAILURE,
  GET_API_KEY_REQUEST,
  GET_API_KEY_SUCCESS,
  SET_FLEET_DASHBOARD_LINK,
  GET_JOB_PROFILE_SUCCESS,
  GET_JOB_PROFILE_REQUEST,

} from './constants';
import { isUserHomeowner } from './helper';

let initialState = {
  message: '',
  messageType: '',
  accountDetail: {},
  currentlySending: true,
  currentlySendingApiGenerateRequest: false,
  isUnauthorized: false,
  accountLoading: false,
  locale: 'en',
  viewOnlyAccess: false,
  viewCannotEdit: false,
  isHomeowner: false,
  trainingDashboardToken: null,
  fleetDashBoardLink: null,
  hideSnakbar: true,
  apiKey: '',
  job_profile_list: [],
  show_job_profile: false
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case ACCOUNT_DETAIL_REQUEST:
      return { ...state, currentlySending: true, accountLoading: action.accountLoading || false };
    case ACCOUNT_DETAIL_SUCCESS:
      return {
        ...state,
        accountDetail: action.accountDetail,
        locale: action.accountDetail.locale || 'en',
        currentlySending: false,
        accountLoading: false,
        viewOnlyAccess: action.viewOnlyAccess,
        viewCannotEdit: action.viewCannotEdit,
        isHomeowner: isUserHomeowner(action.accountDetail)
      };
    case SET_LOCALE_REQUEST:
      return {
        ...state,
        locale: action.payload.locale || 'en'
      };
    case RESET_PASSWORD_REQUEST:
      return { ...state, currentlySending: true };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        message: action.message,
        messageType: 'success',
        currentlySending: false,
        hideSnakbar: false
      };
    case RESEND_CONFIRMATION_EMAIL_REQUEST:
      return { ...state, currentlySending: true };
    case RESEND_CONFIRMATION_EMAIL_SUCCESS:
      return {
        ...state,
        message: action.message,
        messageType: 'success',
        currentlySending: false
      };
    case CANCEL_EMAIL_CHANGE_REQUEST:
      return { ...state, currentlySending: true };
    case CANCEL_EMAIL_CHANGE_SUCCESS:
      return {
        ...state,
        message: action.message,
        messageType: 'success',
        currentlySending: false
      };
    case UPDATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        message: action.message,
        messageType: 'success',
        currentlySending: false,
        hideSnakbar: action.hideSnakbar
      };
    case REQUEST_FAILURE:
      return {
        ...state,
        message: Array.isArray(action.error)? action.error.map(m => `${m}<br/>`).join('') : action.error,
        messageType: 'error',
        currentlySending: false,
        isUnauthorized: action.isUnauthorized || false,
        accountLoading: false,
        hideSnakbar: false
      };
    case SET_TRAINING_DASHBOARD_TOKEN:
      return {
        ...state,
        trainingDashboardToken: action.payload
      };
    case SET_FLEET_DASHBOARD_LINK:
      return {
        ...state,
        fleetDashBoardLink: action.payload
      };
    case GENERATE_API_KEY_REQUEST:
      return { ...state, currentlySendingApiGenerateRequest: true };
    case GENERATE_API_KEY_SUCCESS:
      return {
        ...state,
        currentlySendingApiGenerateRequest: false,
        apiKey: action.apiKey
      };
    case GENERATE_API_KEY_FAILURE:
      return {
        ...state,
        message: action.error,
        messageType: 'error',
        currentlySendingApiGenerateRequest: false
      };
    case GET_API_KEY_REQUEST:
      return { ...state };
    case GET_API_KEY_SUCCESS:
      return {
        ...state,
        apiKey: action.apiKey
      };
    case GET_JOB_PROFILE_REQUEST:
      return { ...state }
    case GET_JOB_PROFILE_SUCCESS:
      return {
        ...state,
        job_profile_list: action.job_profile_list,
        show_job_profile: action.show_job_profile
      }
    default:
      return state;
  }
}

export default reducer;
